import { apiCall } from "./authServices";

export const GetDealerData = async ({ payload }) => {
    try {
        const endpoint = `api/dealer-master/get-dealers`
        const res = await apiCall({
            endpoint: endpoint,
            payload: payload,
            method: "post",
        });
        return res
    } catch (error) {
        throw error;
    }
}

export const UpdateDealer = async ({payload = null, employeeId}) => {

    try {
        const endpoint = `api/dealer-master/update-dealer/${employeeId}`
        const res = await apiCall({
            endpoint: endpoint,
            payload: payload,
            method: "POST",
        });
        return res
    } catch (error) {
        throw error;
    }
}


export const ImportCsvFile = async ({ payload }) => {

    try {
        const endPoint = `api/dealer-master/import-dealer`
        const res = await apiCall({
            endpoint: endPoint,
            payload: payload,
            method: "post",
        });
        return res;
    } catch (error) {
        throw error;
    }
}

export const GetExcelFile = async ({payload}) => {
    try{
        const endpoint = 'api/reports/dealer-master-report'
        const res = await apiCall({
            endpoint: endpoint,
            method: 'POST',
            payload: payload
        })
        return res;
    }catch(error){
        throw error;
    }
}